import { useState } from "react";
import { textTransformation } from "../utils/textTransformation";
import Modal from "./Modal";
import { Notice } from "../interfaces/Notice";
import ImageZoomModal from "./ImageZoomModal";
import {
  TruckIcon,
  ExclamationCircleIcon,
  GiftIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";

interface ModalInfo {
  isOpen: boolean;
  selected: Notice | undefined;
}

interface NoticesProps {
  noticeList: Notice[];
}

interface IconProps {
  title: string;
}

export const IconOfTitle = (props: IconProps): JSX.Element => {
  const { title } = props;

  if (title.includes("택배")) {
    return <TruckIcon />;
  } else if (title.includes("수령")) {
    return <GiftIcon />;
  } else if (title.includes("화장실")) {
    return <HomeIcon />;
  } else if (title.includes("\n")) {
    return <></>;
  }
  return <ExclamationCircleIcon />;
};

export const Notices = (props: NoticesProps) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [modal, setModal] = useState<ModalInfo>({
    isOpen: false,
    selected: undefined,
  });
  const { noticeList } = props;

  const openModal = (row: Notice) => {
    if (modal) {
      setModal({ selected: row, isOpen: true });
    }
  };

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const imageElement = (
    <img
      src={`/assets/images/notice/${modal.selected?.imageUrl}`}
      alt="notice_image"
      onClick={toggleZoom}
      style={{
        cursor: "pointer",
      }}
    />
  );

  return (
    <div>
      <Modal
        isOpen={modal.isOpen}
        onClose={() => setModal({ selected: modal.selected, isOpen: false })}
      >
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          {modal.selected?.title}
        </h2>
        {modal.selected?.imageUrl ? (
          <div>
            {imageElement}
            <ImageZoomModal isOpen={isZoomed} onClose={toggleZoom}>
              {imageElement}
            </ImageZoomModal>
          </div>
        ) : (
          <></>
        )}
        <div className="mb-2">
          <div style={{ whiteSpace: "pre-wrap" }} className="text-gray-700">
            {textTransformation(modal.selected?.content)}
          </div>
        </div>
      </Modal>

      <div className="flex justify-center">
        <table className="my-4 w-full">
          <tbody className="">
            {noticeList !== undefined ? (
              noticeList
                .sort((a, b) => a.id - b.id)
                .map((item, key) => (
                  <tr
                    className="last:border-b cursor-pointer border-gray-500 hover:bg-gray-200 border-t h-16"
                    key={key}
                    onClick={() => openModal(item)}
                  >
                    <td className="px-4 py-2 text-lg md:text-base">
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        <div className="h-7 w-7 absolute md:ml-5 ml-1">
                          <IconOfTitle title={item.title} />
                        </div>
                        {textTransformation(item.title)}
                      </div>
                    </td>
                  </tr>
                ))
            ) : (
              <></>
            )}
          </tbody>
        </table>
      </div>
      <span className="text-sm">
        행사 관련 안내 사항은 수시로 업데이트됩니다
      </span>
    </div>
  );
};
